//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQInput from "@/components/Generics/AQInput/AQInput.vue";

export default {
    components: {
        AQInput
    },
    props: {
        uuid: {
            required: true,
            type: String
        },
        readonly: {
            type: Boolean
        },
        value: String
    },
    data() {
        return {
            dataValue: ""
        };
    },
    watch: {
        value: {
            handler(newValue) {
                this.dataValue = newValue || "";
            },
            immediate: true
        }
    },
    methods: {
        setValue(v) {
            this.$emit("input", v);
        }
    }
};
